export default "__VITE_ASSET__DWROT5xM__"